<ng-container *ngIf="youtubeVideoId; else idNotDefined">
    <div #youtubePlayer class="video-container">
        <youtube-player [videoId]="youtubeVideoId" [playerVars]="playerVars" (stateChange)="onPlayerStateChange($event)" />
    </div>
</ng-container>

<ng-template #idNotDefined>
    <p class="lvl-warning h3 text-center bold mt-5 mb-0">Youtube Id Not Defined.</p>
</ng-template>
